exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-m9k{position:relative;background-color:#fff;font-weight:400;margin-bottom:20px}._1Bdua{display:-webkit-box;display:-ms-flexbox;display:flex}._1fnVA{padding:15px;font-size:14px;border-top:2px solid transparent;cursor:pointer}._1fnVA:hover{color:#e73232}._3rlvG{border-top-color:#ffd906;font-weight:700}._2k-vX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:20px}._1OaSA{display:grid;margin:0 16px 6px;grid-template-columns:repeat(4,1fr);gap:6px}._1BPc4{width:182px}._1BPc4:nth-of-type(4n - 3){margin-left:0}.Ro43B{border:none;outline:none;background-color:transparent;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:15px;cursor:pointer;width:100%;color:#7c7c7c;-webkit-transition:all .1s ease-in;-o-transition:all .1s ease-in;transition:all .1s ease-in;margin-top:2px}.Ro43B:hover{background-color:#ffd906;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2-m9k",
	"header": "_1Bdua",
	"typeBtn": "_1fnVA",
	"currentType": "_3rlvG",
	"loader": "_2k-vX",
	"body": "_1OaSA",
	"advert": "_1BPc4",
	"bottomBtn": "Ro43B"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/commercial/components/TypeCatalog/TypeCatalog.css
// module id = 3042
// module chunks = 24